import React from 'react';

const Logo = ({ size = 'default' }) => {
  const sizes = {
    small: { icon: 28, text: 'text-base' },
    default: { icon: 36, text: 'text-lg' },
    large: { icon: 48, text: 'text-2xl' }
  };

  const { icon, text } = sizes[size];

  return (
    <a href="#" className="flex items-center gap-3 group">
      {/* Logo Icon - Abstract AI/Strategy Symbol */}
      <div 
        className="relative flex items-center justify-center"
        style={{ width: icon, height: icon }}
      >
        <svg 
          viewBox="0 0 40 40" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          {/* Outer hexagon shape */}
          <path 
            d="M20 2L36 11V29L20 38L4 29V11L20 2Z" 
            stroke="url(#gradient1)" 
            strokeWidth="2"
            fill="none"
          />
          {/* Inner connected nodes representing AI/network */}
          <circle cx="20" cy="12" r="3" fill="#3b82f6" />
          <circle cx="12" cy="24" r="3" fill="#3b82f6" />
          <circle cx="28" cy="24" r="3" fill="#3b82f6" />
          <circle cx="20" cy="28" r="2" fill="#60a5fa" />
          {/* Connection lines */}
          <line x1="20" y1="15" x2="20" y2="26" stroke="#3b82f6" strokeWidth="1.5" />
          <line x1="17" y1="13" x2="14" y2="22" stroke="#3b82f6" strokeWidth="1.5" />
          <line x1="23" y1="13" x2="26" y2="22" stroke="#3b82f6" strokeWidth="1.5" />
          <line x1="15" y1="24" x2="25" y2="24" stroke="#60a5fa" strokeWidth="1" opacity="0.6" />
          {/* Gradient definition */}
          <defs>
            <linearGradient id="gradient1" x1="4" y1="2" x2="36" y2="38">
              <stop offset="0%" stopColor="#3b82f6" />
              <stop offset="100%" stopColor="#60a5fa" />
            </linearGradient>
          </defs>
        </svg>
        {/* Glow effect */}
        <div 
          className="absolute inset-0 blur-lg opacity-30 group-hover:opacity-50 transition-opacity"
          style={{ background: 'var(--accent-primary)' }}
        />
      </div>
      
      {/* Company Name */}
      <div className="flex flex-col">
        <span 
          className={`font-semibold ${text} tracking-tight`}
          style={{ color: 'var(--text-primary)' }}
        >
          Strategy Intelligence
        </span>
        <span 
          className="text-xs font-medium tracking-wider uppercase"
          style={{ color: 'var(--accent-primary)' }}
        >
          Solutions
        </span>
      </div>
    </a>
  );
};

export default Logo;
